module.exports = new __parcel__URL__("circle-selected.bac10034.svg").toString();